/** Prefers the selected product name; generic C1 buttons expose their UI type instead. */
export function roombookButtonProductName(productName?: string, buttonType?: string): string {
  const name = productName?.trim();
  if (name) return name;
  if (buttonType === "simple" || buttonType === "Simple") return "einfach";
  if (buttonType === "touch" || buttonType === "Touch") return "touch";
  if (buttonType === "panel" || buttonType === "Panel") return "panel";
  return "";
}
